import { useTrackEvent } from '@optimizely/react-sdk'
import { useCookies } from '@utils/cookies'

export const useOptlyAddToCart = () => {
  const [track] = useTrackEvent()
  const [cookies] = useCookies(['_ga', '__gtm_campaign_url', 'GUID'])

  return function sendOptlyCartAdd(itemId: string) {
    const cleanedItemId = itemId.trim().toLowerCase()

    try {
      if (!cookies?.GUID) {
        throw new Error(
          'No GUID available from cookie in Optimizely add_to_cart_v2 event logger.'
        )
      }

      // We may not need to send GUID through here but I'm worried 'undefined' may not fall back to just the provider context.
      // Docs on the SDK aren't clear either: https://github.com/optimizely/react-sdk
      track('add_to_cart_v2', cookies?.GUID, undefined, {
        item_id: cleanedItemId,
      })
    } catch (trackError) {
      console.error(
        'Error logging add_to_cart_v2 event with itemId:',
        itemId,
        'Full error:',
        trackError
      )
    }
  }
}
